import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { LogOut, ShieldCheck, CalendarCheck, User as UserIcon, Home as HomeIcon, Trophy, Users } from "lucide-react";
import NotificationsBell from "./NotificationsBell";
import BrandLogo from "./BrandLogo";

export default function TopBar() {
    const { user, logout } = useAuth();
    const navigate = useNavigate();

    const handleLogout = async () => {
        await logout();
        navigate("/login");
    };

    const navLinkClass = ({ isActive }) =>
        `inline-flex items-center gap-1.5 px-3 h-9 rounded text-sm font-semibold transition-colors ${
            isActive ? "bg-[#00FF66]/15 text-[#00FF66] border border-[#00FF66]/40" : "text-slate-300 hover:text-white hover:bg-slate-800 border border-transparent"
        }`;

    return (
        <header className="sticky top-0 z-30 bg-slate-950/85 backdrop-blur-xl border-b border-slate-800">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
                <Link to="/" className="flex items-center gap-2" data-testid="brand-link">
                    <BrandLogo size="md" />
                    <div className="leading-tight hidden sm:block">
                        <div className="text-[10px] tracking-[0.25em] text-[#00FF66] uppercase">Multi-sport turf</div>
                    </div>
                </Link>
                <div className="flex items-center gap-2">
                    {user && (
                        <nav className="hidden md:flex items-center gap-1 mr-2">
                            <NavLink to="/" end className={navLinkClass} data-testid="topnav-home">
                                <HomeIcon className="w-4 h-4" /> Home
                            </NavLink>
                            <NavLink to="/events" className={navLinkClass} data-testid="topnav-events">
                                <Trophy className="w-4 h-4" /> Events
                            </NavLink>
                            <NavLink to="/community" className={navLinkClass} data-testid="topnav-community">
                                <Users className="w-4 h-4" /> Community
                            </NavLink>
                            <NavLink to="/bookings" className={navLinkClass} data-testid="topnav-bookings">
                                <CalendarCheck className="w-4 h-4" /> Bookings
                            </NavLink>
                            <NavLink to="/profile" className={navLinkClass} data-testid="topnav-profile">
                                <UserIcon className="w-4 h-4" /> Profile
                            </NavLink>
                        </nav>
                    )}
                    {user && ["super_admin", "admin"].includes(user.role) && (
                        <Link
                            to="/admin"
                            data-testid="admin-link"
                            className="hidden sm:inline-flex items-center gap-2 px-3 h-9 bg-slate-800 hover:bg-slate-700 border border-slate-700 rounded text-sm font-semibold text-white transition-colors"
                        >
                            <ShieldCheck className="w-4 h-4 text-[#00FF66]" />
                            Admin
                        </Link>
                    )}
                    {user ? (
                        <>
                            <NotificationsBell />
                            <button
                                onClick={handleLogout}
                                data-testid="logout-btn"
                                className="hidden sm:inline-flex items-center gap-2 px-3 h-9 bg-slate-800 hover:bg-slate-700 border border-slate-700 rounded text-sm text-slate-200"
                            >
                                <LogOut className="w-4 h-4" />
                                Logout
                            </button>
                        </>
                    ) : (
                        <Link
                            to="/login"
                            data-testid="login-link"
                            className="px-4 h-9 inline-flex items-center bg-[#00FF66] text-black font-bold uppercase text-sm rounded hover:bg-[#00cc52] transition-colors"
                        >
                            Login
                        </Link>
                    )}
                </div>
            </div>
        </header>
    );
}
